import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Paper from "components/Paper";
import Text from "components/Text";
import SuccessImage from "assets/images/success.svg";

import styles from "./index.module.css";

import { clearStorage } from "../../utils/storage";
import { queryClient } from "common/query";
import { QueryKeys, RomanianMonthsShort } from "common/constants";

const ConfirmationPage = () => {
    const history = useHistory();
    const [locationKeys, setLocationKeys] = useState([])
    //----------start data---------------//
    const successData = queryClient.getQueryData(QueryKeys.successData);

    console.log("Date Log :" + new Date(successData?.date))
    //----------end data---------------//

    useEffect(() => {
        if (!successData) {
            history.push("/programare")
        }
        clearStorage();

    }, []);

    useEffect(() => {
        return history.listen(location => {
            if (history.action === 'POP') {
                setLocationKeys((keys) => [location.key, ...keys])
                history.replace("/programare")
            }
        })
    }, [locationKeys,])

    return (
        <div className={styles.confirmationPage}>
            <Paper className={styles.paper}>
                <img
                    src={SuccessImage}
                    alt="successtick"
                    className={styles.successImage}
                />
                <Text type={"h2"} className={styles.alignTextCenter}>
                    Programare confirmată cu succes!
                </Text>
                <div className={styles.programCard}>
                    <Text type={"h3"} className={styles.alignTextCenter}>
                        Număr Programare
                    </Text>
                    <Text type={"l"} className={styles.alignTextCenter}>
                        {successData?.programmingNumber}
                    </Text>
                </div>
                <Text type={"h3"} className={styles.alignTextCenter}>
                    Data și ora programată
                </Text>
                {successData?.date &&
                    <Text type={"l"} className={styles.alignTextCenter}>
                        {new Date(successData?.date).getDate()}  {RomanianMonthsShort[new Date(successData?.date).toLocaleString('default', { month: 'long' })]} {new Date(successData?.date).getFullYear()}, <br />
                        {successData?.time}
                    </Text>
                }
                <Text type={"h3"} className={styles.alignTextCenter}>
                    Serviciu
                </Text>
                <Text type={"s"} className={styles.alignTextCenter}>
                    {successData?.departmentName}
                </Text>
                <Text type={"h3"} className={styles.alignTextCenter}>
                    {successData?.serviceName}
                </Text>
            </Paper>
        </div>
    );
};

export default ConfirmationPage;
